// extracted by mini-css-extract-plugin
export var avatar = "_pt-3";
export var avatarContainer = "_pt-2";
export var avatarSpacer = "_pt-5";
export var avatarSpacerContainer = "_pt-4";
export var avatarStackContainer = "_pt-1";
export var bubble = "_pt-0";
export var remainderBubble = "_pt-6";